// Shared width for the directory count line and the coach-card grid so the
// count stays centered over the grid (not left-aligned to the page edge).
export const DIRECTORY_RESULTS_MAX_WIDTH = 1008
// Matches CoachResults Grid `spacing={2}` (8px padding on each item).
export const DIRECTORY_RESULTS_GUTTER = 8
